import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import './site.css';
import './tokens.css';
import './site-ui.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
